<template>
  <div class="homepage">
    <div class="top">
        <video autoplay muted webkit-playsinline playsinline loop id="background-video">
            <source src="../assets/8292.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
        <div class="big_title">להפיק את המירב מהבניין שלכם עכשיו זה אפשרי</div>
        <div class="desc">המכרז השקוף בהתחדשות עירונית מאפשר לבעלי דירות, בפעם הראשונה בישראל, 
לנהל תהליך דיגיטלי יעיל ונוח לבחירת היזם המתאים לפרויקט שלכם, בשקיפות מלאה לכל אורך התהליך.</div>
        <router-link :to="{name: 'login'}" class="btn">להתחלת התהליך <div class="icon arrow_left_icon"></div></router-link>
    </div>
    <div id="tama38">
        <div class="sml_title">למה לקחת סיכון כשאפשר ללכת על בטוח?</div>
        <div class="title">התחדשות עירונית, רק עם המכרז השקוף</div>
        <swiper :spaceBetween="30" :autoplay="{ delay: 4000, disableOnInteraction: true, }" :pagination="{dynamicBullets: true,}" :modules="modules" class="tama_swiper" style="--swiper-pagination-bottom: 0;">
            <swiper-slide class="tama_card" v-for="card in tama_cards" :key="card.title">
                <div class="content">
                    <div class="title" v-text="card.title"></div>
                    <div class="desc" v-text="card.text"></div>
                </div>
                <div class="pic" :style="bg(card.pic_parsed)"></div>
            </swiper-slide>
        </swiper>
        <router-link :to="{name: 'login'}" class="btn">להתחלת התהליך <div class="icon arrow_left_icon"></div></router-link>
    </div>
    <div id="lawyers">
        <div class="head_carusel">
            <div class="title">עורכי דין שכבר עובדים עם המכרז השקוף</div>
            <div class="carusel_nav" v-if="!is_mobile()">
                <div class="prev" @click="goToPrevSlide('lawyers_swiper')"></div>
                <div class="next" @click="goToNextSlide('lawyers_swiper')"></div>
            </div>
        </div>
        <div class="carusel">
            <swiper :slidesPerView="is_mobile() ? 1 : 4.5"  :autoplay="{ delay: 4000, disableOnInteraction: true, }" :modules="modules" :spaceBetween="is_mobile() ? 50 : 30" :pagination="{clickable: true}" class="lawyers_swiper">
                <swiper-slide v-for="lawyer in lawyers" :key="lawyer.name">
                    <a :href="lawyer.link" target="_blank" class="card">
                        <div class="pic_details_wrap">
                            <div class="pic" :style="bg(lawyer.pic_parsed)"></div>
                            <div>
                                <div class="name" v-text="lawyer.name"></div>
                                <div class="job" v-text="lawyer.office"></div>
                            </div>
                        </div>
                        <div class="logo" :style="bg(lawyer.logo_parsed)"></div>
                    </a>
                </swiper-slide>
            </swiper>
        </div>
        <!-- <a href="" target="_" class="btn">לרשימה המלאה</a> -->

    </div>
    <div id="how">
        <div class="centered">
            <div class="title"></div>
            <div class="how_img"></div>
            <div class="title"></div>
        </div>
    </div>
     <div id="how_mobile">
        <div class="centered">
            <div class="title_mobile"> איך זה עובד?</div>
            <div class="how_steps_mobile">
                <div class="how_step" >
                    <div class="step_number teal">1</div>
                      <div class="step_desc">מקבלים מאתנו מספר הצעות לעורכי דין מובילים ובוחרים את העו"ד שמתאים עבורכם.  כבר בחרתם עו"ד? ודאו איתו שהוא עובד עם המכרז השקוף
                        </div>
                    </div>

                    <div class="how_step" >
                        <div class="step_number purple">2</div>
                            <div class="step_desc">מגדירים יחד עם העו"ד פרמטרים חשובים לפרויקט, והוא יוצר עבורכם מכרז עם לוחות זמנים מוגדרים להגשת הצעות
                            </div>
                    </div>
               
                    <div class="how_step" >
                        <div class="step_number blue">3</div>
                        <div class="step_desc">לאחר פרסום המכרז במערכת, יזמים רבים הרלוונטיים לפרויקט נחשפים למכרז ומגישים אליו מועמדות</div>
                    </div>

                    <div class="how_step" >
                        <div class="step_number teal">4</div>
                        <div class="step_desc">המערכת משווה בין הצעות היזמים, בוחנת אם הם עומדים בהגדרות המכרז ומעניקה ציון לכל יזם </div>
                    </div>

                    <div class="how_step" >
                        <div class="step_number purple">5</div>
                        <div class="step_desc">מחליטים מיהם היזמים הרלוונטים לפרויקט וקובעים פגישת היכרות לבדיקת התאמה</div>
                    </div>

                    <div class="how_step">
                        <div class="step_number blue">6</div>
                        <div class="step_desc">בוחרים את היזם המתאים עבורכם, ויוצאים לדרך</div>
                    </div>
            </div>
            <div class="title_mobile">ככה מבטיחים תהליך יעיל ואפקטיבי לפרויקט ההתחדשות העירונית שלכם!</div>
        </div>
    </div>
    <div id="quotes">
        <div class="head_carusel">
            <div class="title">עדויות מדיירים שהשתמשו במערכת שלנו</div>
            <div class="carusel_nav" v-if="!is_mobile()">
                <div class="prev" @click="goToPrevSlide('quotes_swiper')" ></div>
                <div class="next" @click="goToNextSlide('quotes_swiper')" ></div>
                <!-- <div class="prev" @click="goToPrevSlide('quotes_swiper')" :class="{active: quotes_swiper.prev}"></div>
                <div class="next" @click="goToNextSlide('quotes_swiper')" :class="{active: quotes_swiper.next}"></div> -->
            </div>
        </div>
        <div class="carusel">
            <swiper :navigation="true" :slidesPerView="is_mobile() ? 1 : 3.5"  :autoplay="{ delay: 4000, disableOnInteraction: true, }" :modules="modules" :spaceBetween="is_mobile() ? 50 : 30" :pagination="{clickable: true}" class="quotes_swiper">
                <swiper-slide v-for="quote in quotes" :key="quote.name">
                    <div class="card">
                        <div class="text" v-html="quote.content"></div>
                        <div class="name_job">
                            <div class="name" v-text="quote.name"></div>
                            <div v-text="quote.city"></div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
    <div class="bottom" id="form_section">
        <div class="project_tama">
            <div class="your_tama">
                <div class="title">פרויקט ההתחדשות העירונית שלכם, מתחיל כאן.</div>
                <div class="desc">
                    ספרו לנו מי אתם ובאיזה שלב אתם נמצאים,
                    ואנחנו נחבר אתכם עם מספר עורכי דין מובילים שעובדים עם המכרז השקוף.
                    אם כבר בחרתם עו"ד, נלווה אתכם ליצירת מכרז בתהליך דיגיטלי יעיל ונוח.
                </div>
            </div>
            <div class="service">
                <div class="title2 no_fee">השירות ללא עלות</div>
                <div class="title no_commit">וללא התחייבות</div>
            </div>
        </div>
        <div class="contact">
            <div v-for="step in contact" :key="step.name" >
                <div v-if="contact[active_step] == step">
                    <div class="contact_head">
                        <div class="title" v-text="step.name"></div>
                        <div class="step">שלב {{active_step+1}} מתוך {{contact.length}}</div>
                    </div>
                    <form class="form" @submit.prevent="sendForm">
                        <div class="input_wrap">
                            <li v-for="field in step.fields" :key="field.title">
                                <label v-text="field.title"></label>
                                <div v-if="field.options">
                                    <wzselect v-model="form[field.name]" :settings="{ theme: 'light', customClass: 'wz-select-homepage', width: '100%',height: '100%' }" :options="field.options.map(row => { return { key: `${row.key}`, val: `${row.val}` } })" />
                                </div>
                                <input v-else :type="field.type ?? 'text'" :placeholder="field.placeholder" v-model="form[field.name]">
                            </li>
                        </div>
                        <button class="btn" @click="active_step = 1" v-if="contact[active_step+1] !== undefined" v-text="step.btn_text"></button>
                        <input class="btn" v-else type="submit" :value="step.btn_text">
                    </form>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
// import 'swiper/css/navigation';

export default {
    components: { Swiper, SwiperSlide},
    setup() {
      return {
        modules: [Pagination,Autoplay],
      };
    },
    data(){
        return {
            quotes_swiper: {
                prev: false,
                next: true,
            },
            lawyers: [
                {
                    name: "עו”ד דרור הראל",
                    job: "משרד דרור הראל ושות’",
                    logo: "https://s3-alpha-sig.figma.com/img/a2af/73a2/c2b807930749d20e9dc7dce0e69beef9?Expires=1708905600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=fkBTK3fBf2GbuyvyO7-y1q2jXgFrQLHuHaf-jJUr8d0CmUSbPp4BBNdf3SI~Qjr~0JF4VXN8~fRtAL91Cxka15qyXcDhCHBaplp8GgyYDTgQxt~M-EBjfMcTgFL6i5iQGMCxVtgpLBfu8GjOl2mjeexv5VA0knD6HsDuZsrGOwbhxCGsO38kvvQT33OGUipM3cT3lIv4d5z8m8U0oqvuNBPp74ezBkezcFST7A1SLFLOK84KfEu7equYv4IiGCe8lLjw~PpwcwoTvbF5GDh6cyXtPA5nC-jA4UdtkWBqxC5LPFN0CCuHnRyrPfPbegXpLjmB-yCCt1xaWxhvS1XlkQ__",
                    pic: "https://s3-alpha-sig.figma.com/img/a4c6/e6b1/1676785c43ecf9f6c464762b607a3a5d?Expires=1708905600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=NliEYP5F93Fv4LVe~TDJ0VbYap-vbgm5MFaO70m6XYBiXWjT8iyfr-tJqhbJsK0MCizrNRQkqdCJ9T64fte2R50HAEYjsXaN7gGdtt~WP5KhnZ8kyfYgCkIUgF0zQQ-2reTy-MyALhTMMS7gFd8GW86NAk9Cn4ZUiNzbrsOl~WJ3UcSbOBhUGOR4HEzvS0jP5~QH4ecAg2qHgcdsagt6ntrHFDturvqKTHDPoN1aCe1ChmoJNVCyWegA2XXAaDrf7yhaVSnoHnwBgyTfGRVGbb1Iza91vgiaDj9z2ANKJC9Jshwv63d4YHNFFBNZvrTmDWgaL4A2s3YgwCoVWnmPRA__",
                }
            ],
            quotes: [
                {
                    text: `תהליך של התחדשות עירונית זה עניין לא פשוט בכלל. 

                    אני אשמח להעיד בשם כל הנציגות כשאני אומר שהכל הפך להיות פשוט ברגע שבחרנו לעבוד עם המערכת של המכרז השקוף, ואת התוצאות כבר אפשר לראות בשטח.`,
                    quotemaster: "רונן ברגמון",
                    location: "רמת-גן"
                }
            ],
            tama_cards: [
                {title: "ללא עלות", desc: `המכרז השקוף היא מערכת פתוחה וללא עלות לבעלי דירות ולעו"ד שמעוניינים בקידום פרויקט התחדשות עירונית`, pic: "https://s3-alpha-sig.figma.com/img/7adf/aec4/8ec966370ae6fb98c131a2920e8775b4?Expires=1708905600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Srwysiw6uYLQL~FcLHIjMer6s1pirKVX5itiGboVJbNtAtOv3sbl0rjfZXVU~mOuow3KjaV6jdqlRurvb4jhSpFWXJzXcVnsphHOE1u~hd0LVvspR1v4ytsrCFqDtzAz5h7UaAhOAG68hYbX~xFVy~C~SmSyxXjBYTY2iHB9pDn4fTMLXrV3YppClw9BWYI-5Q9fnHbuPyO29HBZocM5S0gipa2Z8QxkqU6ivRIZdhKXqu02dv4EYcZ-PrkLDX2HovKTEGOFFuMCUYT2lWvtWJKAl2c5aIThwcJhF0rrbRs2ANp4x72vIKBrzhZqB75bZygiJ5TLQEULNSmvszBzbg__"},
            ],
            active_step: 0,
            form: {},
            contact: [
                // no options = input style is text
                {
                    name: "פרטים אישיים",
                    fields: [
                        {name: "email", title: `דוא"ל`,type: "email"},
                        {name: "phone", title: `טלפון נייד`,type: "tel"},
                        {name: "address", title: `כתובת הבניין`, placeholder: "רחוב, מס’ בית ועיר"},
                    ],
                    btn_text: "המשך",
                },
                {
                    name: "פרטים על הבניין",
                    fields: [
                        {name: "before_80s", title: "האם הבניין נבנה לפני 1980?", options: [{ key: 1, val: "כן"}, { key: 0, val: "לא"}]},
                        {name: "representative", title: "אני פונה מטעם", options: [{ key: 'representation_apartment_owners', val: "נציגות בעלי הדירות"},{ key: 'apartment_owner', val: "עצמי - בעל דירה"}]},
                        {name: "project_stage", title: "באיזה שלב נמצא הפרויקט?", options: [{key: "initial_inquiry",val: "בירור ראשוני"},{ key: "choosing_attorney", val: "בחירת עו”ד"}, {key: "create_prj", val: "יצירת מכרז"},{key: 'choosing_entrepreneur', val: "בחירת יזם (המכרז הסתיים)"}]},
                    ],
                    btn_text: "שליחה",
                }
            ]
        }
    },
    mounted() {
        this.api({ action: 'langind_data', method: 'get'}, (data)=>{
            if (data.data) {
                this.quotes = data.data.testimonies
                this.lawyers = data.data.lawyers
                this.tama_cards = data.data.cards
            }
        })
    },
    methods: {
        goToNextSlide(swiperClass) {
            const swiper = document.querySelector('.'+swiperClass).swiper
            swiper.slideNext();
        },
         goToPrevSlide(swiperClass) {
            const swiper = document.querySelector('.'+swiperClass).swiper
            swiper.slidePrev();
        },
        sendForm() {
            
            console.log(this.form);
            
            this.api({ action: 'landing_contact', data: { ...this.form }}, (data)=>{
                if (data.data) {
                    this.alert(this.get_word('contact_landing'))
                } else {
                    this.alert("שגיאה, נסה שוב מאוחר יותר")
                }
                this.form = {
                    address: '',
                    before_80s: '',
                    email: '',
                    phone: '',
                    project_stage: '',
                    representative: ''
                }
            })
            
        }
    }
}
</script>

<style lang="scss" >
.homepage { --swiper-pagination-bottom: -5px; 
* { color: var(--homepage_blue); }
}
.swiper-wrapper { padding-block: var(--gap_xmid) !important;}
.swiper-slide { height: auto;}

*{ font-size: var(--h4); }
.title {
    &{font-family: var(--font2);}
    @media (min-width: 600px) {font-size: var(--h6);}
    @media (max-width: 600px) { font-size: 32px; line-height: 1; }
}
.homepage {
    &{ width: 100%;height: 100%;background: white; }
    @media (min-width: 600px) {}
    @media (max-width: 600px) {display: flex;flex-direction:column;align-items:center;gap:var(--gap_big);margin-bottom: 50px;}
    &>* {
        @media (min-width: 600px) {margin: 120px var(--gap_big);}
        @media (max-width: 600px) {width: 90%;}
    }
    .top {
        &{width: 100%;height: 95vh;position: relative;;background-size: cover;background-repeat: no-repeat;background-position: bottom;display: flex;flex-direction: column;align-items: center;gap: var(--gap_small);margin: 0;margin-top: -120px;}
        #background-video { position: absolute; top: 50%; left: 50%; width: 100%; height: 100%; object-fit: cover; transform: translate(-50%, -50%);}
        &::before{content: '';position: absolute;top: 0;left: 0;width: 100%;height: 95vh;background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.15) 100%);z-index: 1;}
        *{z-index: 2;}
        .big_title,.desc {
            &{color: white;text-align: center;}
            @media (min-width: 600px) {max-width: 50%;}
            @media (max-width: 600px) {max-width: 80%;}
        }
        .big_title {
            &{font-weight: 700;margin-top: 20vh;}
            @media (min-width: 600px) {font-size: 70px;}
            @media (max-width: 600px) {font-size: 40px; line-height: 1.1;}
        }
        .desc {
            @media (min-width: 600px) {font-size: 26px;}
            @media (max-width: 600px) {font-size: 18px; line-height: 1.2; margin-top: 10px;}
        }
        .btn {margin-top: var(--gap_xbig);
        &:hover{gap: var(--gap_mid);}}
    }
    #tama38 {
        &{display: flex;flex-direction: column;justify-content: center;align-items: center;text-align: center;gap: var(--gap_small);}
        .sml_title{
            @media (min-width: 600px) {font-size: var(--h3);}
            @media (max-width: 600px) {font-size: var(--h4);}
        }
        .title{
            @media (min-width: 600px) {font-size: var(--h2);}
            @media (max-width: 600px) {font-size: var(--h3);}
        }
        .tama_swiper {
            @media (min-width: 600px) {padding: 20px 10px;width: 80%; margin-bottom: 16px;}
            @media (max-width: 600px) {padding: 25px 5px;width: 100%;}
            .tama_card {
                &{display: flex;justify-content: space-between;align-items: center;border: 3px solid rgba(255, 255, 255, 0.38);box-shadow: -2px 0px 8px 1px rgba(1, 4, 117, 0.09);}
                @media (min-width: 600px) {padding:100px;border-radius: 70px;}
                @media (max-width: 600px) {padding:20px;border-radius: var(--radius_x);flex-direction:column;}
                .content {
                    &{display: flex;flex-direction: column;gap: var(--gap_small);max-width: 500px;}
                    @media (min-width: 600px) {text-align: start;}
                    @media (max-width: 600px) {text-align: center;}
                    .title {
                        @media (min-width: 600px) {font-size: var(--h2);}
                        @media (max-width: 600px) {font-size: 30px}
                    }
                    .desc {
                        @media (min-width: 600px) {font-size: var(--h3);}
                        @media (max-width: 600px) {font-size: var(--h4);}
                    }
                    }
                .pic {
                    &{background-size: contain;background-repeat: no-repeat;aspect-ratio: 1;}
                    @media (min-width: 600px) {width: 400px;}
                    @media (max-width: 600px) {width: 90%;}
                }
            }
        }
    }
    #lawyers, #quotes {
        &{display: flex;flex-direction: column;}
        @media (min-width: 600px) {border-radius: 70px;padding: var(--gap_xbig) 0;}
        @media (max-width: 600px) {border-radius: var(--radius_x);padding: var(--gap_mid) 0;}
        .head_carusel {
            &{display: flex;justify-content: space-between;}
            @media (min-width: 600px) {padding: 0 120px;align-items: center}
            @media (max-width: 600px) {text-align: center;max-width:90%;align-self:center;}
            .title { font-size: var(--h2);}
            .carusel_nav {
                display: flex;height: fit-content; border-radius: 40px;
                .prev,.next {
                    &{width: 35px; height: 35px;background-size: contain !important;background-repeat: no-repeat !important;background-position: center !important;border: 1px solid #0105756f;}
                    &:hover{cursor: pointer}
                    // &:not(.active) { opacity: 0.4;}
                }
                .prev {background: url("../assets/nav-arrow.svg");border-radius: 40px 0 0 40px;transform: rotate(180deg);}
                .next {background: url("../assets/nav-arrow.svg");border-radius:40px 0 0 40px;}
                
                
            }
        }
        .carusel {
            
            .card {
                &{ height: 100%; justify-content: space-between; background: white;border-radius: var(--radius_x);display: flex;flex-direction: column;justify-content: center;align-items: center;color:var(--homepage_blue)}
                @media (min-width: 600px) {gap: var(--gap_big); }
                @media (max-width: 600px) {gap: var(--gap);padding:10px 20px; margin: 10px;}
                .pic_details_wrap{
                    &{display: flex;flex-direction: column;justify-content: center;align-items: center;text-align: center;}
                    @media (min-width: 600px) {gap:var(--gap_mid);}
                    @media (max-width: 600px) {gap:var(--gap); }
                    .pic {   width:150px;aspect-ratio: 1;background-size: contain;background-repeat: no-repeat;border:5px solid white;border-radius: 100%;box-shadow: 0px 0px 12px 0px rgba(79, 89, 115, 0.16);}
                }
                .name {font-weight: 700;font-family: var(--font2);}
                .logo {  filter: grayscale(1); width:130px;aspect-ratio: 1.5;background-size: contain;background-repeat: no-repeat;}
            }
        }
        .btn {background: var(--homepage_blue);color: white;align-self: center;margin-top: var(--gap_mid);}
    }
    #lawyers {
        &{background: var(--card_blue_bg);}
        .card {box-shadow: 6px 6px 10px 0px #B4BBCB;
            .pic { background-position: center;}
        }
    }
    #how {
        .how_img { background-image: url(../assets/how_it_works_section.png); background-position: center; background-size: contain; background-repeat: no-repeat; aspect-ratio: 9/14; }
    }
    #how_mobile{
        display: none;
    }
    #quotes {
        &{background: var(--card_green_bg);}
        .card {
            *{z-index: 1;}
            &{align-items: start !important;box-shadow:6px 6px 10px 0px rgba(205, 204, 125, 0.33);}
            @media (min-width: 600px) {padding: 30px 45px;}
            @media (max-width: 600px) {padding: 20px 35px !important;}
            .name {font-size: var(--h3);}
            // .text {font-weight: 600;}
            
            &::before,&::after {content: '';position: absolute;background: url('../assets/quote.svg');background-size: contain;background-repeat: no-repeat;width: 100px;height: 60%;z-index: 0;top: 0;}
            &::before {right: 40%;}
            &::after {right: 10%;}
        }
    }
    .bottom {
        &{display: flex;flex-direction: column;}
        @media (min-width: 600px) {gap: var(--gap_big);padding: 60px 120px;}
        @media (max-width: 600px) {gap: var(--gap_mid);}
        .project_tama {
            &{display: flex;}
            @media (min-width: 600px) {gap: var(--gap_big);}
            @media (max-width: 600px) {flex-direction: column;gap: var(--gap_mid);}
            .your_tama {
                &{background: #A93CBD;}
                @media (min-width: 600px) {flex: 1;}
                @media (max-width: 600px) {}
                *{
                    @media (min-width: 600px) {max-width:600px;}
                    @media (max-width: 600px) {max-width: 90%;}
                }
                .title { font-size: var(--h1); line-height: 1; margin-bottom: var(--gap);}
                .desc {font-size: var(--h4);}
            }
            .service {
                &{ position: relative;  background: #0A34A8;display: flex;flex-direction: column;justify-content: center;align-items: center;text-align: center; height: 100%; aspect-ratio: 1;}
                &::after {content: '';position: absolute;right: 0;top: 0;width: 100%;height: 100%;background: url('../assets/8775.png');background-size: cover;background-repeat: no-repeat;}
                *{font-family: var(--font2);}
                .no_fee {
                    @media (min-width: 600px) {font-size: 37px;}
                    @media (max-width: 600px) {font-size: 32px;}
                }
                .no_commit {
                    @media (min-width: 600px) {font-size: 43px;}
                    @media (max-width: 600px) {font-size: 38px;}
                }
            }
        }
        .your_tama, .service,.contact {
            &{border: 4px solid var(--white, #FFF);box-shadow: 20px 20px 50px 0px rgba(180, 187, 203, 0.45), 6px 6px 12px 0px #B4BBCB;}
            @media (min-width: 600px) {border-radius: 70px 70px 70px 10px;padding: 110px 95px;}
            @media (max-width: 600px) {border-radius: 40px 40px 40px 10px;padding: 20px}
            *{color: white}
        }
        .contact {
            &{background: var(--homepage_blue);}
            .contact_head {
                &{display: flex;justify-content: space-between;align-items: center; margin-bottom: var(--gap);}
                @media (min-width: 600px) {}
                @media (max-width: 600px) {flex-direction: column-reverse;justify-content:center; align-items: center;margin-bottom: var(--gap);gap: var(--gap_small)}

                .title { font-size: var(--h2);}
            }
            .form {
                --wz-input-height: 50px;
                &{display: flex;gap: var(--gap);justify-content: center;align-items: center;}
                @media (min-width: 600px) {}
                @media (max-width: 600px) {flex-direction: column;}
                .input_wrap {
                    @media (min-width: 600px) {flex-basis: 90%;display: grid;grid-template-columns: repeat(3,1fr);gap: var(--gap);}
                    @media (max-width: 600px) {display: flex;flex-direction:column;gap: var(--gap_small);width: 100%;}
                    li {
                        display: flex;flex-direction: column;gap: var(--gap_small);
                        input {height: 50px;color: var(--hompage_text_blue);}
                    }
                }
                .btn {flex-basis: 10%;height: 50px;align-self: flex-end;}
            }
        }
    }
}
.btn {
    width: fit-content;display: flex;gap:var(--gap);padding: var(--gap) var(--gap_xmid);background: #12DCB6;
    @media (min-width: 600px) {font-size: var(--h3);}
    @media (max-width: 600px) {font-size: var(--h5);}
}

@media (max-width: 768px) {
   .homepage{
    .bottom .project_tama .your_tama .title {
        font-size: 36px;
    }

    .top{
        .desc{
            font-weight: 600 ;
        }
    }
    #how{
        display: none;
    }
    #how_mobile{
      display: block;
        .title_mobile{
            font-size: var(--h3);
            font-family: var(--font2);
            text-align: center;
            
            margin:  var(--gap_mid) 0;
        }
        .how_steps_mobile{
            display: flex;
            flex-direction: column;
            gap: var(--gap_small);
            .how_step{
                .step_number{
                    width: 50px;
                    height: 50px;
                    border-radius: 25%;
                    padding: var(--gap_xmid);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    background-color: #FFF;
                    top:25px;
                    right: 50%;
                    transform: translateX(50%); ;
                    font-size: var(--h2);
                    font-weight: 700;
                    
                }
                .teal{
                    box-shadow: 5px 5px 0px 1px #16ECC4, 2px 3px 6px 4px #00000029;
                }
                .purple{
                    box-shadow: 5px 5px 0px 1px #C551DA, 2px 3px 6px 4px #00000029;
                }
                .blue{
                    box-shadow: 5px 5px 0px 1px #1065CC, 2px 3px 6px 4px #00000029;
                }
                .step_desc{
                    font-size: var(--h4);
                    gap: var(--gap_small);
                    background-color: #092e9519;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    padding:var(--gap_big) var(--gap_mid) var(--gap_mid) var(--gap_mid);
                    border-radius: var(--radius_x);
                }

            }
        }
    }   
   }
}
</style>